import { render } from "./TrayPanelLiveData.vue?vue&type=template&id=2735d857&scoped=true"
import script from "./TrayPanelLiveData.vue?vue&type=script&lang=js"
export * from "./TrayPanelLiveData.vue?vue&type=script&lang=js"

import "../styles/TrayPanelLiveData.scss?vue&type=style&index=0&id=2735d857&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2735d857"]])

export default __exports__